/** Canonical English keys stored in D1 — never store translated labels as values. */

export const ANIMAL_TYPES = ['dog', 'cat', 'other'] as const
export type AnimalType = (typeof ANIMAL_TYPES)[number]

export const COLORS = [
  'black',
  'white',
  'brown_chocolate',
  'tan_fawn',
  'red_orange',
  'gray_blue',
  'cream_yellow',
  'gold_apricot',
] as const
export type ColorKey = (typeof COLORS)[number]

export const OWNERSHIP_STATUSES = [
  'confirmed_owned',
  'confirmed_abandoned',
  'no_known_owner',
  'reported_lost',
] as const
export type OwnershipStatus = (typeof OWNERSHIP_STATUSES)[number]

export const SUPPORTED_LOCALES = ['en', 'es', 'pap', 'nl'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

/** Aruba approximate center */
export const ARUBA_CENTER = { lat: 12.5211, lng: -69.9683 }
export const DEFAULT_ZOOM = 12
